/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

import {BaseComponent, CrmProject} from 'compob2b-libs';

import {FormGroup} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {Router} from '@angular/router';
import {NbDialogRef} from '@nebular/theme';


@Component({
    selector: 'app-marketplace-categories-modal',
    templateUrl: './move-to-project-modal.component.html',
    styleUrls: ['./move-to-project-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MoveToProjectModalComponent extends BaseComponent implements OnInit {
  loading = false;

  timeForm: FormGroup;
  issueId: number;
  issueName: string;

  allProjects: CrmProject[] = [];

  selectedRow: CrmProject;

  timeMove = true;

  constructor(protected readonly router: Router,
              private readonly dialogRef: NbDialogRef<any>) {
    super();
  }


  ngOnInit(): void {

    this.compoApiService.get<CrmProject[]>('/projects/list-projects')
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        this.loading = false;
        this.allProjects = response.data;
        this.cdr.detectChanges();
      });
  }

  change(event) {
    console.log(event);
    this.selectedRow = event;
    this.cdr.detectChanges();
  }

  moveToProject() {
    if (this.selectedRow === undefined) {
      alert('Выберите проект!');
      return false;
    }
    this.compoApiService.post('/issue/move-to-project', {
      issueId: this.issueId,
      projectId: this.selectedRow.id,
      timeMove: this.timeMove
    }).pipe(takeUntil(this.unsubscribe))
      .subscribe(_ => {
        this.successToast('Сохранено');
        this.dialogRef.close();
      });
  }

  checkValue(values) {
    console.log(values.currentTarget.checked);
    this.timeMove = values.currentTarget.checked;
    this.cdr.detectChanges();
  }

}
